import { useState } from 'react';

const FALLBACK_SRC = '/images/placeholder.svg';

interface NotificationImageProps {
    src: string;
    alt: string;
}

// The parent keys this component by src so updated notification images can load.
export default function NotificationImage({ src, alt }: NotificationImageProps) {
    const [stage, setStage] = useState<'original' | 'fallback' | 'unavailable'>('original');

    if (stage === 'unavailable') {
        return (
            <div role="img" aria-label={alt} className="w-full h-full flex items-center justify-center text-gray-400 text-3xl">
                📢
            </div>
        );
    }

    return (
        <img
            src={stage === 'original' ? src : FALLBACK_SRC}
            alt={alt}
            className="w-full h-full object-cover"
            onError={() => setStage(current =>
                current === 'original' && src !== FALLBACK_SRC ? 'fallback' : 'unavailable'
            )}
        />
    );
}
